import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'

import * as Vue from 'vue' // in Vue 3
import axios from 'axios'
import VueAxios from 'vue-axios'
import './assets/themes/main.less';
import './index.css'

import vueColumnsResizable from './middleware/vue-columns-resizable';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import store from './store/store'

/* import specific icons */
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

import {customizations} from "@/customizations/customizations";

//Add all icons to the library so you can use it in your page
library.add(fas, far, faUserSecret)

import { settings } from '../settings.config.js'

import cookieHelper from "./application/CookieHelper";
import {useStore} from "vuex";

if(typeof window.electron === "undefined") {
  
  window.maxApplicationWidth = 996;
}


window.crossApi = {
  callbacks: {},
  signals: [],
  onClickPlaceholder : () => {},
  emit: function(type, value) {
    this.signals.forEach((signal) => {
      if(signal.type === type) {
        signal.callback(value);
      }
    });
  },
  connect: function (type, callback) {
    this.signals.push({type: type, callback: callback});
  },
};

window.electronCallbacks = {};
try {
  window.electronAPI.receiveFromMain('runScriptResponse', (result) => {
    if(window.electronCallbacks[result.uuid] !== undefined) {
        window.electronCallbacks[result.uuid](result);
    }
  });
} catch(e) {
    
}

customizations.init();


//import VueCollapsiblePanel from '@dafcoe/vue-collapsible-panel'

window.$ = require('jquery');
window.JQuery = require('jquery');

let messages = {
  en: {
    tab: {
      title: {
        picturesearch: "Image & Logo Search",
        articletemplate: "Article Templates",
        clipboard: "Clipboard"
      }
    },
    app: {
      menu : {
        product: "Article"
      }
    },
    asset : {
      search_placeholder: "Search..."
    }
  },

  de: {
    tab: {
      title: {
        picturesearch: "Bilder- & Logosuche",
        articletemplate: "Artikel-  vorlage",
        clipboard: "Zwischen- ablage",
        pagetemplates: "Seiten-  vorlagen"
      }
    },
    app: {
      menu : {
        product: "Artikel",
        asset: "Assets",
        logout: "Abmelden"
      }
    },
    asset : {
      search_placeholder: "Suche..."
    }
  },
  ru: {
    app: {
      menu : {
        product: "Продукт"
      }
    },
    tab: {
      title: {
        picturesearch: "Поиск изображений и логотипов",
        articletemplate: "Шаблон статьи",
        clipboard: "Клипборд"
      }
    }
  }
}
messages.en.app.project = {};
messages.en.app.project.navigation = {};
messages.en.app.project.navigation.page = "Page";
messages.en.app.project.navigation.document = "Magazine";
messages.en.app.project.navigation.project = "Project";

messages.de.app.project = {};
messages.de.app.project.navigation = {};
messages.de.app.project.navigation.page = "Seite";
messages.de.app.project.navigation.document = "Magazin";
messages.de.app.project.navigation.project = "Projekt";

messages.ru.app.project = {};
messages.ru.app.project.navigation = {};
messages.ru.app.project.navigation.page = "Страница";
messages.ru.app.project.navigation.document = "Журнал";
messages.ru.app.project.navigation.project = "Проект";

const i18n = createI18n({
  locale: 'de', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages
})

window.i18n = i18n;
window.runningElectron = false;

let storesSuccessfullLoaded = false

const app = createApp(App);

if(typeof window.electronAPI === "undefined") {
  window.runningElectron = false;
  app.config.globalProperties.runningInElectron = false;
} else {
    window.runningElectron = true;
  app.config.globalProperties.runningInElectron = true;
}


app.config.globalProperties.$isParamDefined = function(param) {
  return this.$route.params[param] != null && this.$route.params[param] !== '';
};

router.beforeEach((to, from, next) => {

  app.config.globalProperties.showMenu = true;
  let jwt = cookieHelper.getCookie("jwt");

  

  //init stores
  if( storesSuccessfullLoaded === false && to.path !== "/login") {
    try {
      useStore().dispatch('team/init');
        useStore().dispatch('user/init');
      storesSuccessfullLoaded = true;
    } catch (e) {
      storesSuccessfullLoaded = false;
    }
  }



  if(typeof window.electron !== "undefined") {

    let windowType = "project";
    if(to.path.indexOf("/asset") > -1) {
      windowType = "asset";
    }

    if(to.path.indexOf("/product") > -1) {
      windowType = "product";
    }

    //window.electron.setWindowType(windowType);
  }



  if(to.path.indexOf("/assetproductdetail") > -1) {
    app.config.globalProperties.showMenu = false;
    return next();
  }
 
  if (to.path === "/") {
    router.push('/login');
  } else if (to.path === "/logout") {
    axios.post('/api/v3/logout', {}).then((response) => {}).catch((error) => {});
    router.push('/login');
  } else if (to.path === "/login") {
    if (jwt !== "") {
      router.push('/project');
    } else {
      next();
    }
  } else {
    next();
  }
});

app.provide('appConfig', settings);

/* add font awesome icon component */
app.use(i18n);

app.use(vueColumnsResizable);




//app.use(VueCollapsiblePanel);
app.use(store);
app.use(VueAxios, axios)
app.component("font-awesome-icon", FontAwesomeIcon)
app.use(router).mount('#app');
